export function formatCurrency(amount){
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        trailingZeroDisplay: "stripIfInteger",
        maximumFractionDigits: 2, 
        minimumFractionDigits: 0, 
    });
    return formatter.format(amount);

}